<template>
    <div class="form">
      <div class="form_logo">
        <img src="@/assets/form_logo.png" alt="">
      </div>
        <div class="form-box">
            <div class="tabs">
                <div class="tabs_title">活动报名</div>
                <div class="identity_tabs">
                    <div
                            @click="handleTab(index)"
                            class="tabs_item"
                            :class="index==tabIndex?'selected':''"
                            v-for="(item,index) in tabs" :key="index">
                        {{item}}
                    </div>
                </div>
            </div>
            <div class="form_content">
                <div class="form_item">
                    <div class="item_title">姓名<span>*</span></div>
                    <van-field v-model="form.name" placeholder="请输入用户名" />
                </div>
                <div class="form_item">
                    <div class="item_title">手机号</div>
                    <van-field v-model="form.mobile" type="tel" placeholder="请输入您的手机号" />
                </div>
                <div class="form_item">
                    <div class="item_title">{{tabIndex==1?'入职年份':'入学年份'}}</div>
                    <van-field v-model="form.year" :placeholder="tabIndex==1?'请选择入职年份':'请选择入学年份'" readonly @click="handleYear"/>
                </div>
                <div class="form_item" v-if="tabIndex!=1">
                    <div class="item_title">就读院系</div>
                    <van-field v-model="form.learnDept" placeholder="请输入您的院系" />
                </div>
                <div class="form_item" v-if="tabIndex!=1">
                    <div class="item_title">就读专业</div>
                    <van-field v-model="form.major" placeholder="请输入您的专业" />
                </div>
                <div class="form_item" v-if="tabIndex==1">
                    <div class="item_title">工作部门</div>
                    <van-field v-model="form.workDept" placeholder="请输入您的工作部门" />
                </div>
            </div>
            <div class="commit" >
                <div class="commit_inner" @click="commit">立即报名</div>
            </div>
        </div>
      <div class="form-alert">天涯虽远 云光寄思</div>
        <van-popup v-model="showPickerY" position="bottom">
            <van-datetime-picker
                    :type="yearType"
                    v-model="currentDate"
                    :min-date="minDate"
                    :max-date="maxDate"
                    title="选择入学年份"
                    @cancel="onCancel"
                    @confirm="onConfirmTime"/>
        </van-popup>
    </div>
</template>

<script>
import {formCommit} from '../../utils/ajaxInterface'
import { Dialog } from 'vant'
export default {
  name: 'index',
  data () {
    return {
      showPickerY: false,
      yearType: 'year-month',
      minDate: new Date(1951, 0, 1),
      currentDate: new Date(),
      maxDate: new Date(2026, 11, 31),

      form: {name: '', mobile: '', year: '', learnDept: '', major: '', workDept: ''},
      tabIndex: 0,
      tabs: ['校友', '教职工', '在校学生']
    }
  },
  created () {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo.status) {
      this.$router.push('/map')
    }
  },
  methods: {
    commit () {
      let {name, mobile, year, learnDept, major, workDept} = this.form
      if (!name) {
        Dialog.alert({
          title: '提示',
          message: '请输入姓名'
        })
        return
      }
      if (mobile && !(/^1[34578]\d{9}$/.test(mobile))) {
        Dialog.alert({
          title: '提示',
          message: '请输入正确格式的手机号'
        })
        return
      }
      let params = {}
      if (this.tabIndex == 1) {
        params = { category: this.tabIndex + 1, name, mobile, year, workDept }
      } else {
        params = {category: this.tabIndex + 1, name, mobile, year, learnDept, major}
      }
      formCommit(params).then(res => {
        Dialog.alert({
          title: '提示',
          message: '报名成功'
        }).then(() => {
          let userInfo = JSON.parse(localStorage.getItem('userInfo'))
          userInfo.status = true
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
          this.$router.push('/bless')
          // this.$router.push('/map')
          // on close
        })
      }).catch(e => {
        this.$toast.fail(e)
      })
    },
    onCancel () {
      this.showPickerY = false
    },
    // 选择计分年度
    onConfirmTime (val) {
      // 将字符串转换为Date对象
      var date = new Date(val)
      // 使用getFullYear()方法获取年份
      this.form.year = date.getFullYear()
      this.showPickerY = false
    },
    handleYear () {
      this.showPickerY = true

      this.$nextTick(() => {
        if (this.yearType === 'year-month') {
          // 删除月份列
          let columns = this.$el.querySelectorAll('.van-picker__columns .van-picker-column')
          if (columns.length === 2) {
            columns[1].parentElement.removeChild(columns[1])
          }
        }
      })
    },
    handleTab (index) {
      this.tabIndex = index
      this.form = {}
    }
  }
}
</script>

<style scoped lang="less">
    .form {
        background: url("../../assets/active_bg.png") center center no-repeat;
        background-size: cover;
        min-height: 100vh;
        padding: 40px 0 0;
        box-sizing: border-box;
        .form_logo{
          width: 234px;
          height: 33px;
          margin: 0 auto 30px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .form-box {
            background: url("../../assets/active_small_bg.png") center center no-repeat;
            background-size: cover;
            height: 524px;
            width: 335px;
            padding: 20px 20px 0;
            box-sizing: border-box;
            position: relative;
          margin: 0 auto;
            .commit{
                position: absolute;
                bottom: 44px;
                left: 0;
                /*transform: translateX(-80px);*/
                width: 100%;
                height: 47px;
                padding: 0 20px;
                box-sizing: border-box;
                .commit_inner{
                    margin: 0 auto;
                    width: 245px;
                    height: 47px;
                  background: linear-gradient( 90deg, #1891FE 0%, #0EBDFF 100%);
                    border-radius: 20px;
                    line-height: 47px;
                    text-align: center;
                    font-weight: 500;
                    font-size: 17px;
                    color: #FFFFFF;
                }
            }

            .tabs {
                .tabs_title {
                  font-size: 24px;
                  color: #444444;
                  margin-bottom: 18px;
                  width: 100px;
                  height: 36px;
                  line-height: 60px;
                  border-bottom: 4px solid transparent; /* 必须预留边框占位，transparent透明 */
                  border-image: linear-gradient( 90deg, #00A0E9 0%, rgba(0,103,221,0.02) 100%) 1;
                }

                .identity_tabs {
                    display: flex;

                    .tabs_item {
                        width: 80px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        border-radius: 15px;
                        margin-right: 14px;
                        font-size: 14px;
                        background: #F6F6F6;
                        color: #000000;
                    }

                    .selected {
                        border: 1px solid #00A0E9;
                      color: #00A0E9;
                      background: rgba(0,160,233,0.05);
                    }
                }
            }

            .form_content {
                margin-top: 10px;
                .form_item{
                    width: 100%;
                    height: 42px;
                    border-bottom: 1px solid #DADADA;
                    border-radius: 2px;
                    display: flex;
                    padding: 0 14px;
                    box-sizing: border-box;
                    align-items: center;
                    margin-bottom: 12px;
                    /deep/ .van-cell{
                        line-height: 40px;
                        padding: 0 15px;
                        background-color: transparent;
                    }
                    .item_title{
                        width: 80px;
                        font-size: 14px;
                        color: #000000;
                        span{
                            color: red;
                        }
                    }
                }
            }
        }
      .form-alert{
        margin-top: 30px;
        font-weight: bold;
        font-size: 26px;
        color: #004594;
        text-align: center;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/form/index.vue